import { OpeningConfigLine, OpeningMode } from '@gozoki/api-types';
import { Button, Stack } from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DateTime } from 'luxon';
import { OpeningHoursPicker } from './OpeningHoursPicker';
import { OpeningModePicker } from './OpeningModePicker';

export const HourConfigCard = ({
    isAddButton,
    openingConfigCard,
    buttonClick,
    modify,
}: {
    isAddButton: boolean;
    openingConfigCard: OpeningConfigLine;
    buttonClick: () => void;
    modify: (openingMode: OpeningMode, beginTime: DateTime, endTime: DateTime) => void;
}) => {
    const setOpeningMode = (newOpeningValue: OpeningMode) => {
        modify(
            newOpeningValue,
            DateTime.fromISO(openingConfigCard.beginTime),
            DateTime.fromISO(openingConfigCard.endTime)
        );
    };

    const setBeginTime = (newBeginValue: DateTime) => {
        modify(
            openingConfigCard.openingMode,
            newBeginValue,
            DateTime.fromISO(openingConfigCard.endTime)
        );
    };

    const setEndTime = (newEndValue: DateTime) => {
        modify(
            openingConfigCard.openingMode,
            DateTime.fromISO(openingConfigCard.beginTime),
            newEndValue
        );
    };
    return (
        <Stack gap={1} p={1} flexDirection="row">
            <OpeningModePicker
                currentValue={openingConfigCard.openingMode}
                setOpeningMode={(openingMode: OpeningMode) => {
                    setOpeningMode(openingMode);
                }}
            />
            <LocalizationProvider dateAdapter={AdapterLuxon}>
                <OpeningHoursPicker
                    label="Ouverture"
                    value={DateTime.fromISO(openingConfigCard.beginTime)}
                    setValue={setBeginTime}
                />
                <OpeningHoursPicker
                    label="Fermeture"
                    value={DateTime.fromISO(openingConfigCard.endTime)}
                    setValue={setEndTime}
                />
            </LocalizationProvider>
            <Button sx={{ color: '#1D1B19' }} onClick={buttonClick}>
                {isAddButton ? <AddIcon /> : <DeleteIcon />}
            </Button>
        </Stack>
    );
};
